import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";

export default reducers => {
  const persistedReducer = persistReducer(
    {
      key: "corob",
      storage,
      whitelist: ["auth","impersonate","language"]
    },
    reducers
  );

  return persistedReducer;
};
